import { CustomReportsRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

function AnalysisCustomReportsRoute() {
  const { workspaceId } = Route.useParams();
  return <CustomReportsRoute segment="analysis" workspaceId={workspaceId} />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/analysis/custom-reports/')({
  component: AnalysisCustomReportsRoute,
});
